module.exports = __webpack_public_path__ + "static/media/prebuilt-solution.58b3b56c.png";